import React, { Component, ReactNode } from 'react';
import './SignupHatUrl.scss';
import '../../../assets/style/_tooltip.scss';
import { NotificationBanner } from '../../shared/NotificationBanner/NotificationBanner';
import { get } from '../../../services/BackendService';
import { Routes, SandboxRoutes } from '../../../app/AppRouter';
import { Link } from 'react-router-dom';
import { AUTH_API_URL } from '../../../app.config';

const debounce = require('lodash.debounce');

const HAT_URL_REGEX = /^[a-z][a-z0-9]{2,19}[a-z0-9]$/;
const SPECIAL_CHARS_REGEX = /[_~\-!"`¬|:;'#@$£%^&.,*()<>]+/;
const NUMBER_FIRST_CHAR_REGEX = /^\d+/;

const ERROR_MESSAGES: { [key: string]: string } = {
  lengthError: 'The name must be between 4 to 21 characters.',
  uppercaseError: 'The name cannot contain uppercase letters.',
  specialCharsError: `The name cannot contain special characters. (eg.  - _ # % /)`,
  mustStartWithLetterError: 'The name must start with a letter.',
  genericError: `The format of the name is incorrect.`,
  hatExistsError: 'A HAT with this name already exists.',
};

export class SignupHatUrl extends Component<IUrlCreateProps, IUrlCreateState> {
  state = {
    url: '',
    validUrl: true,
    notAvailableUrl: false,
    urlError: false,
    sandbox: false,
    urlErrorType: '',
  };

  validateUrlDebounce = debounce((name: string) => this.validateUrl(name), 400);
  loginLink = this.props.sandbox ? SandboxRoutes.hatLogin : Routes.hatLogin

  async validateUrl(name: string) {
    try {
      const res = await get(`${AUTH_API_URL}/api/validate-hatname?name=${name}&sandbox=${this.props.sandbox}`);
      if (res.parsedBody) {
        this.setState({
          notAvailableUrl: false,
        });

        this.props.hatUrlNext(this.state.url);
      }
    } catch (err) {
      this.setState({
        urlError: true,
        urlErrorType: 'hatExistsError',
        notAvailableUrl: true,
      });
    }
  }

  onUrlChange(url: string) {
    this.setState({
      url: url,
    });
  }

  inputFocus = () => {
    this.setState({
      notAvailableUrl: false,
      urlErrorType: '',
      urlError: false,
    });
  };

  onNextClicked = () => {
    const validUrl = HAT_URL_REGEX.test(this.state.url);
    this.setState({
      validUrl: validUrl,
    });

    if (validUrl) {
      this.validateUrlDebounce(this.state.url);
    } else {
      this.urlDetailedError(this.state.url);
    }
  };

  urlDetailedError(url: string) {
    let errorType = '';
    if (url.length < 4 || url.length > 21) {
      errorType = 'lengthError';
    } else if (url !== url.toLowerCase()) {
      errorType = 'uppercaseError';
    } else if (url.search(SPECIAL_CHARS_REGEX) >= 0) {
      errorType = `specialCharsError`;
    } else if (url.search(NUMBER_FIRST_CHAR_REGEX) >= 0) {
      errorType = 'mustStartWithLetterError';
    } else {
      errorType = `genericError`;
    }

    this.setState({
      urlError: true,
      urlErrorType: errorType,
    });
  }

  render(): ReactNode {
    return (
      <div className="hatters-flex-column-container">
        {this.state.urlError && (
          <NotificationBanner type={'error'} message={ERROR_MESSAGES[this.state.urlErrorType] || ''} />
        )}

        <span className={'flex-spacer-small'} />

        <div className="url-wrapper">
          <div className="url-title-container">
            <div className="hatters-title">Create your URL</div>
          </div>

          <div className="hatters-description-normal">Choose a name for your HAT PDA's unique URL.</div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.onNextClicked();
            }}
          >
            <div className={'url-input-wrapper'}>
              <input
                className="hatters-input"
                name={'hatname'}
                type={'text'}
                placeholder="yourname"
                style={this.state.urlError ? { borderColor: '#E45151' } : {}}
                maxLength={21}
                onFocus={this.inputFocus}
                onChange={(e) => this.onUrlChange(e.target.value)}
              />
              <div className={'url-hat-domain'}>
                {this.props.sandbox ? (
                  <div className={'tooltip'}>
                    .hubat.net
                    <div className={'tooltip-text'}>All test HATs have this domain.</div>
                  </div>
                ) : (
                  '.hubofallthings.net'
                )}
              </div>
            </div>
          </form>

          <div className="hatters-description-small">
            Your name must
            <ul className={'url-list'}>
              <li>start with a letter</li>
              <li>contain alphanumeric characters only</li>
              <li>contain lowercase letters only</li>
              <li>be between 4 to 21 characters</li>
            </ul>
          </div>

          <div className="url-user-actions">
            <button className="hatters-btn hatters-btn-accent" onClick={() => this.onNextClicked()}>
              Next
            </button>

            <div className="hatters-description-normal">
              Have an account? <Link to={this.loginLink}>Log in</Link>{' '}
            </div>
          </div>
        </div>

        <span className={'flex-spacer-large'} />
      </div>
    );
  }
}

interface IUrlCreateState {
  url: string;
  validUrl: boolean;
  notAvailableUrl: boolean;
  urlError: boolean;
  urlErrorType: string;
}

interface IUrlCreateProps {
  hatUrlNext: Function;
  cancelClicked: Function;
  sandbox: boolean;
}
